"use client";

import {ImageEditor, ImageEditorImage, ImageEditorImageType, ImageOptions} from "../../shared/StyledCamera";
import React, {ReactElement, useState} from "react";
import {Button} from "@mui/material";
import {CheckOutlined} from "@mui/icons-material";
import {SZ_SM} from "../../shared/dimens";
import Cropper, {Area, Point} from "react-easy-crop";

function CropImageView({image, aspectRatio, onCropComplete}: {
  image: ImageEditorImage,
  aspectRatio: number,
  onCropComplete: (cropArea: Area, cropAreaPixels: Area) => void
}): ReactElement {
  const [crop, setCrop] = useState<Point>({x: 0, y: 0});
  const [zoom, setZoom] = useState<number>(1);
  return <Cropper
    image={image.data}
    crop={crop}
    zoom={zoom}
    aspect={aspectRatio}
    onCropChange={setCrop}
    onCropComplete={onCropComplete}
    onZoomChange={setZoom}
    objectFit={image.cropped ? "contain" : "cover"}
  />
}


async function cropImage(image: ImageEditorImage, cropAreaPixels: Area): Promise<ImageEditorImage> {
  if (!cropAreaPixels) {
    return image;
  }
  const cropped = Object.assign(document.createElement('canvas'), {
    width: cropAreaPixels.width,
    height: cropAreaPixels.height
  });
  const ctx = cropped.getContext('2d');
  const load = new Image();
  const promise = new Promise<ImageEditorImage>((resolve, reject) => {
    load.onload = () => {
      ctx.drawImage(load, cropAreaPixels.x, cropAreaPixels.y, cropAreaPixels.width, cropAreaPixels.height, 0, 0, cropAreaPixels.width, cropAreaPixels.height);
      resolve({
        data: cropped.toDataURL("image/jpeg"),
        type: ImageEditorImageType.BASE64URL,
        cropped: true,
      });
    }
    load.onerror = event => reject(event);
  });
  load.src = image.data;
  return promise;
}

export class SimpleImageEditor implements ImageEditor {

  private cropAreaPixels: Area;

  render(image: ImageEditorImage, onDone: (image: ImageEditorImage) => void, options?: ImageOptions): React.ReactElement {
    return <>
      <CropImageView
        image={image} aspectRatio={options?.keepAspectRatio || 1}
        onCropComplete={(cropArea, cropAreaPixels) => this.cropAreaPixels = cropAreaPixels}/>
      <Button
        onClick={() => {
          cropImage(image, this.cropAreaPixels).then(cropped => onDone(cropped));
        }}
        startIcon={<CheckOutlined/>} variant="contained"
        style={{borderRadius: SZ_SM, position: "absolute", top: 16, left: 16}}>
        Done
      </Button>
    </>;
  }
}